import useSWR from 'swr'
import useAuth from '@crystal-eyes/hooks/useAuth'
import useProfileId from './useProfileId'
import { fetchV3ApiAuthed } from '@crystal-eyes/utils/apis/v3Api'

interface Identity {
  id: string
}

type Options = {
  identity?: Identity
}

export type State = {
  data?: { D: number; I: number; S: number; C: number }
  loading?: boolean
  error?: any
}

export default function useDiscSignalCounts({ identity }: Options = {}): State {
  const { data: auth } = useAuth()
  const { data: profileId } = useProfileId({ identity: identity! })

  const fetcher = ([__key, __authedUser, profileId]: [
    string,
    string,
    string,
  ]) =>
    fetchV3ApiAuthed(auth, `profiles/${profileId}/frequency_table`, {
      method: 'GET',
    }).then(res => res.json())

  const {
    data: queryData,
    isLoading: loading,
    error: error,
  } = useSWR(
    auth?.authToken && profileId
      ? ['useDiscSignalCounts', auth?.jwtPayload?.sub, profileId]
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
      keepPreviousData: true,
    },
  )

  return {
    data: (queryData as any)?.frequency_table,
    loading,
    error,
  }
}
